var navOpen = false;

var menuTogle = document.getElementById("menu-toggle");
var menu = document.getElementById("menu");
var shadowOverlay = document.getElementById("shadow");

function openNav() {
  menu.style.display = "block";
  shadowOverlay.style.display = "block";
  navOpen = true;
}
  
function closeNav() {
  menu.style.display = "none";
  shadowOverlay.style.display = "none";
  navOpen = false;

}

menuTogle.addEventListener("click", function() {
  if (navOpen) {
    closeNav();
  } else {
    openNav();
  }
});

shadowOverlay.addEventListener("click", closeNav);

document.addEventListener("keydown", function(evt) {
  evt = evt || window.event;
  if (evt.keyCode == 27) closeNav();
});
